import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';

import { EnvironmentService, ErableHttpService, ReturnType } from '@ecm/consumer';

import { Family } from '../business/api/family/family';
import { KenobiTrackingCode } from '../business/model/tracking/kenobiTrackingCode-model';

@Injectable({
    providedIn: 'root',
})
export class FamilyService {
    private readonly httpErable = inject(ErableHttpService);
    private readonly environmentService = inject(EnvironmentService);

    public isFamilyEligible(kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<boolean> {
        const env = this.environmentService.instant();
        if (env.API.FAMILY.FAMILY_URL) {
            return this.httpErable
                .get(env.API.FAMILY.FAMILY_URL, {
                    returnType: ReturnType.HTTP_RESPONSE,
                    feature: 'dashboard',
                    pageId,
                    functionality: kenobiTrackingCode['functionality'],
                    partner: 'ZCF',
                    service: 'families',
                })
                .pipe(
                    map((response: HttpResponse<any>) => {
                        return response.status === 200 || response.status === 204;
                    }),
                    catchError(() => {
                        return of(false);
                    }),
                );
        } else {
            return throwError(() => 'FAMILY_URL is false');
        }
    }

    /**
     * Family query
     * @returns {Observable<Family>}
     */
    public getFamily(kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<Family> {
        return this.requestInitFamily(kenobiTrackingCode, pageId);
    }

    /**
     * XHR nested requests to FAMILY endpoint
     * @returns {Observable<any>}
     */
    private requestInitFamily(kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<any> {
        const env = this.environmentService.instant();
        if (env.API.FAMILY.FAMILY_URL) {
            return this.httpErable.get(env.API.FAMILY.FAMILY_URL, {
                feature: 'dashboard',
                pageId,
                functionality: kenobiTrackingCode['functionality'],
                partner: 'ZCF',
                service: 'families',
            });
        } else {
            return throwError(() => 'FAMILY_URL is false');
        }
    }
}
